const getSubscriptionType = (me) => {
  const { subscription, professional } = me || {};

  return subscription?.plan?.id || professional?.organization?.subscriptionType || null;
};

export default getSubscriptionType;
